export default __webpack_public_path__ + "static/media/pf-female.icon.a7178645.svg";